import { lazyLoad } from 'utils/loadable';

export const ProductList = lazyLoad(
  () => import('./index'),
  module => module.default,
);
